export default __webpack_public_path__ + "static/media/sharpTickIcon copy.17cac63a.svg";